export default __webpack_public_path__ + "static/media/CUARZO AZUL.ac2fb148.jpg";